import { ReactNode, useMemo, useState } from 'react';

import {
  WorkspaceTabsContext,
  WorkspaceTabsContextType,
} from './WorkspaceTabsContext';
import { WorkspaceTabs } from './WorkspaceV2';

type WorkspaceTabsContextWrapperProps = {
  children: ReactNode;
};

export const WorkspaceTabsContextWrapper = ({
  children,
}: WorkspaceTabsContextWrapperProps) => {
  const [currentTab, setCurrentTab] = useState(WorkspaceTabs.YOUR_DOCUMENTS);
  const [isReadyForExport, setIsReadyForExport] = useState(false);

  const workspaceTabsContext: WorkspaceTabsContextType = useMemo(
    () => ({
      currentTab: currentTab,
      setCurrentTab: (tab: WorkspaceTabs) => {
        setCurrentTab(tab);
      },
      isReadyForExport,
      setIsReadyForExport,
    }),
    [currentTab, isReadyForExport],
  );

  return (
    <WorkspaceTabsContext.Provider value={workspaceTabsContext}>
      {children}
    </WorkspaceTabsContext.Provider>
  );
};
